import { getActionAuthorization } from '../commons/utils';

const INVENTORIES_STOCKS_ACTIONS_RESOURCE = {
  VIEW: 'inventory:view',
  CREATE: 'inventory:create',
  CREATE_INIT: 'inventory:create:init',
  EDIT_INVENTORY_DATE: 'inventory:edit:inventory-date',
  DELETE: 'inventory:delete',
  EDIT: 'inventory:edit',
  CORRECT: 'inventory:correct',
  DOWNLOAD_SHEET: 'inventory:download',
  VALIDATE_INVENTORY: 'inventory:validate',
  INVALIDATE_INVENTORY: 'inventory:invalidate',
};

export const canViewInventory = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.VIEW);

export const canCreateInventory = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.CREATE);

export const canCreateInitialisationInventory = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.CREATE_INIT);

export const canEditInventoryDate = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.EDIT_INVENTORY_DATE);

export const canDeleteInventory = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.DELETE);

export const canEditInventory = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.EDIT);

export const canCorrectInventory = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.CORRECT);

export const canDownloadInventorySheet = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.DOWNLOAD_SHEET);

export const canValidateInventory = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.VALIDATE_INVENTORY);

export const canInvalidateInventory = (actions) =>
  getActionAuthorization(actions, INVENTORIES_STOCKS_ACTIONS_RESOURCE.INVALIDATE_INVENTORY);
